export const OUTPUT_PANEL_BREAKPOINT = 750;
export const OUTPUT_PANEL_BREAKPOINT_MEDIA_QUERY = `(min-width: ${OUTPUT_PANEL_BREAKPOINT}px)`;
